import { ApiRoutes } from "@/enums/apiRoutes.enum";
import axios from "@/lib/axios";

export interface AdminResponse {
  isAdmin: boolean;
  passwordChanged: boolean;
  role: 'editor' | 'viewer' | null;
}

export const adminService = {
  async checkAdmin(email: string): Promise<AdminResponse> {
    const { data } = await axios.post<AdminResponse>(ApiRoutes.ADMIN_CHECK, {
      email,
    });
    return data;
  },
};
